import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { DevanType } from "./models/DevanType";
@Injectable({
    providedIn: 'root'
})
export class DevanManagementService {
    static serviceName: string = "devanManagementService";

    constructor(private httpClient: HttpClient) { }

    getDevanType(isActiveOnly: boolean, isForDevan: boolean = false, isForPack: boolean = false): Observable<DevanType[]> {
        const params = new HttpParams()
            .set('isForDevan', `${isForDevan}`)
            .set('isForPack', `${isForPack}`)
            .set('isActiveOnly', `${isActiveOnly}`);

        return this.httpClient.get<DevanType[]>(`api/container/devanType`, { params });
    }
}
